'use strict';

import { action, observable, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

class AnnouncerStore {
    messageMap = this.getDefaultMessageMap();

    constructor() {
        makeObservable(this, {
            messageMap: observable,
            announce: action
        });
    }

    // Update announcer element with messaging, only message is required, default level is polite
    announce(message, level = "polite") {
        this.messageMap = {
            text: message,
            level: level
        };
    }

    /**
     * Default blank data. Level options are:
     * off (no messaging), polite (messaging given at next available point), assertive (messaging interrupts everything)
     * @return {{level: string, text: string}}
     */
    getDefaultMessageMap() {
        return {
            text: "",
            level: "off"
        };
    }
}

export default new AnnouncerStore();